export default __webpack_public_path__ + "static/play-green-1a10456f3baf7a7e63003d9efb0db2c2.png";